<template>
  <div :id="this.id" class="h100"></div>
</template>

<script type="text/ecmascript-6">
// 引入基本模板
let echarts = require("echarts/lib/echarts");
export default {
  name: "",
  data() {
    return {};
  },
  props: {
    id: Number,
    // color: String,
    detaildata: Array,
    xAxisdata: Array,
    title: String
  },
  mounted() {
    // console.log(this.detaildata,this.xAxisdata);
    this.drawLine(this.id, this.detaildata);
    this.chartAuto();
  },
  watch: {
    detaildata: {
      handler(newQuestion, oldQuestion) {
        this.$nextTick(() => {
          this.drawLine(this.id, newQuestion);
        });
      },
      deep: true
    },
    xAxisdata: {
      handler(newQuestion, oldQuestion) {
        this.$nextTick(() => {
          this.xAxisdata = newQuestion;
        });
      },
      deep: true
    }
  },
  methods: {
    drawLine(id, bardata) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById(id));
      let newdata = [];
      bardata.forEach((item, index) => {
        let a = {
          value: item,
          symbolPosition: "end"
        };
        newdata.push(a)
      });
      // 绘制图表
      let option = {
        title:{
          text: this.title == undefined?'':this.title,
          textStyle:{
            color:'#b0b5c4',
            fontSize:14,
            fontWeight:400
          },
          top:'8%'
        },
        grid: {
          left: "2%",
          right: "2%",
          bottom: "18%"
        },
        xAxis: {
          data: this.xAxisdata,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,
            interval: 0,
            textStyle: {
              color: "#b0b5c4"
            },
            margin: 20
          }
        },
        yAxis: {
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: false,
            textStyle: {
              color: "#b0b5c4"
            }
          }
        },
        series: [
          {
            name: "",
            type: "pictorialBar",
            symbolSize: [20, 10],
            symbolOffset: [0, -5],
            z: 12,
            itemStyle: {
              normal: {
                color: "#00f2ff"
              }
            },
            data: newdata
          },
          {
            name: "",
            type: "pictorialBar",
            symbolSize: [20, 10],
            symbolOffset: [0, 5],
            z: 12,
            itemStyle: {
              normal: {
                color: "#027eff"
              }
            },
            data: bardata
          },
          {
            name: "",
            type: "pictorialBar",
            symbolSize: [30, 15],
            symbolOffset: [0, 8],
            z: 11,
            itemStyle: {
              normal: {
                color: "transparent",
                borderColor: "#027eff",
                borderWidth: 1
              }
            },
            data: bardata
          },
          {
            name: "",
            type: "pictorialBar",
            symbolSize: [40, 20],
            symbolOffset: [0, 11],
            z: 10,
            itemStyle: {
              normal: {
                color: "transparent",
                borderColor: "#027eff",
                borderType: "dashed",
                borderWidth: 1
              }
            },
            data: bardata
          },
          {
            type: "bar",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#00f2ff"
                  },
                  {
                    offset: 1,
                    color: "#027eff"
                  }
                ]),
                opacity: 0.7
              }
            },
            label: {
              show: true,
              position: 'top',
              color: "#000"
            },
            silent: true,
            barWidth: 20,
            barGap: "-100%", // Make series be overlap
            data: bardata
          }
        ]
      };

      myChart.setOption(option);
    },
    chartAuto() {
      let myChart = this.$echarts.init(document.getElementById(this.id));
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/common/circlebar.vue